import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';
import { Link } from "react-router-dom";
import "./header.css"

function Header() {
   const gettop=()=>{
    window.scrollTo({
      top:0,
      behavior:"smooth"
    })
  }
  return (
    <Navbar expand="lg" className="nav">
      <Container>
<Navbar.Brand href="#home">
  <i className="fas fa-clinic-medical"></i> Medora Center
</Navbar.Brand>        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
         <Nav className="ms-auto">
  <Nav.Link href="#home">
<Link to="/" className="nav-link" onClick={gettop}>  <i className="fas fa-home"></i> Home</Link>
  </Nav.Link>
  <Nav.Link href="#about">
    <Link to="/about" className="nav-link"  onClick={gettop}>  <i className="fas fa-info-circle"></i>  About Us</Link>
  </Nav.Link>
  <Nav.Link href="#services">
        <Link to="/Services" className="nav-link"  onClick={gettop}>     <i className="fas fa-cogs"></i>  Services</Link>
  </Nav.Link>
  <Nav.Link href="#doctors">
            <Link to="/Doctors" className="nav-link"  onClick={gettop}>  <i className="fas fa-user-md"></i>  Doctors</Link>
  </Nav.Link>
  <Nav.Link href="#contact">
                <Link to="/Contact" className="nav-link"  onClick={gettop}> <i className="fas fa-envelope"></i>  Contact Us</Link>
  </Nav.Link>
  <Nav.Link href="#booking">
                    <Link to="/Booking" className="nav-link"  onClick={gettop}>  <i className="fas fa-calendar-check"></i>  Booking</Link>
  </Nav.Link>
  <Nav.Link href="#blog">
     <Link to="/Blog" className="nav-link"  onClick={gettop}>    <i className="fas fa-blog"></i> Blog</Link>
  </Nav.Link>
</Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;